export default __webpack_public_path__ + "static/media/accueil-footer.135383dc.jpg";